import { useCallback, useMemo, useState } from 'react';
import { supportedColumnsFromMonday } from '../../../config/common';

const useLineItemSettings = () => {
  const [tableRef, setTable] = useState(null);

  const [subItemColumns, setSubItemColumns] = useState([]);

  const setDefaultSubItems = useCallback((subItems = []) => {
    setSubItemColumns(subItems);
  }, []);

  const columnOptions = useMemo(() => {
    if (!subItemColumns?.length) {
      return [];
    }
    const columnOptions = subItemColumns?.[0]?.column_values?.map((col) => ({
      ...col,
      label: col.title || col.column.title,
      checked: false,
    }));
    const filteredColumnOptions = columnOptions.filter((x) =>
      supportedColumnsFromMonday.includes(x.type),
    );
    return filteredColumnOptions;
  }, [subItemColumns]);

  return {
    tableRef,
    columnOptions,
    setTable,
    setDefaultSubItems,
  };
};

export default useLineItemSettings;
